module.exports = "../study/imgs/maps/Nagano/S8/Helth/Mosquito/Nagano_Mosquito_MIROC5_RCP26_Now.png";